export const LINE_CHART_CONFIG: Highcharts.Options = {
  title: {
    text: "",
    align: "left",
  },
  chart: {
    type: "spline",
  },
  yAxis: {
    title: {
      text: "",
    },
    accessibility: {
      rangeDescription: "Range:  22 Jan to 13 Feb",
    },
  },
  tooltip: {
    shared: false,
    split: true,
  },
  credits: {
    enabled: false,
  },
  legend: {
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom",
  },
  plotOptions: {
    series: {
      label: {
        connectorAllowed: false,
      },
      pointStart: 0,
      // The x-axis is the UNION of every series' dates (see
      // wrapperFunctionForLine in LineRenderer), so a series that simply has
      // no reading on some date gets a null there rather than being absent.
      // Without this, Highcharts breaks the line at each of those nulls and a
      // series with sparse dates renders as disconnected fragments — the gap
      // reads as "volume stopped" when it only means "nothing reported that
      // day". Joining across them keeps the trend continuous; the missing
      // date still has no marker, so a real reading is never implied.
      connectNulls: true,
    },
  },
  series: [],
  exporting: {
    enabled: true,
    fallbackToExportServer: true,
    sourceWidth: 1400,
    sourceHeight: 600,
    scale: 2,
    chartOptions: {
      chart: {
        marginRight: 30,
      },
      xAxis: {
        labels: {
          step: 1,
          rotation: -45,
        },
      },
    },
    buttons: {
      contextButton: {
        align: "right",
        verticalAlign: "top",
        y: -43,
        x: -30,
      },
    },
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 500,
        },
        chartOptions: {
          legend: {
            layout: "horizontal",
            align: "center",
            verticalAlign: "bottom",
          },
        },
      },
    ],
  },
  accessibility: {
    enabled: false,
  },
};
